<template>
    <div class="column is-one-quarter left-side theme-style">
        <car-specs :car="car"></car-specs>
        <auc-info :car="car"></auc-info>
        <inland-cost :lot="car"></inland-cost>
        <delete-car v-if="isAdmin" :car="car"></delete-car>
        <delete-car-modal v-if="isAdmin" :car="car"></delete-car-modal>
        <transfer-car-modal v-if="isAdmin" :car="car"></transfer-car-modal>

        <video-box v-if="isMobile" :car="car"></video-box>
        <div class="other-section" v-if="isMobile">
            <translate-box :car="car"></translate-box>
            <comments-box :car="car"></comments-box>
        </div>
    </div>
</template>

<script>
    import CarSpecs from './Details/CarSpecs'
    import AucInfo from './Details/AucInfo'
    import DeleteCar from './Details/DeleteCar'
    import DeleteCarModal from './Details/DeleteCarModal'
    import TransferCarModal from './Details/TransferCarModal'
    import InlandCost from './Details/InlandCost'
    import VideoBox from './VideoBox.vue'
    import CommentsBox from './CommentsBox'
    import TranslateBox from './Details/TranslationBox'
    export default {
        props: ['car'],
        components: {
            carSpecs: CarSpecs,
            aucInfo: AucInfo,
            DeleteCar,
            DeleteCarModal,
            TransferCarModal,
            InlandCost,
            VideoBox,
            CommentsBox,
            TranslateBox
        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isMobile() {
                return document.documentElement.clientWidth < 450;
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Car/LeftSide.vue